import { IonFooter } from "@ionic/react";
import styled from "styled-components";
import { LangButton } from "./LangButton";
import { CSSProperties } from "react";
import { useTranslate } from "../../contexts/translate";

function getBackgroundPath(background: "home" | "cards") {
  switch (background) {
    case "home":
      return "home/background.jpg";
    case "cards":
      return "cards/Paper.png";
  }
}

const Container = styled.div<{ background: "home" | "cards" }>`
  @media (orientation: landscape) and (max-width: 400px) {
    ion-footer {
      display: none;
    }
  }

  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/assets/ui/${({ background }) =>
    getBackgroundPath(background)}");

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Footer = styled(IonFooter)`
  display: flex;
  flex-direction: rows;
  align-items: flex-end;
  justify-content: space-between;

  span {
    font-size: 0.8em;
  }

  margin-top: auto;
  padding: calc(5 * var(--u));
  position: absolute;
  bottom: 0;
`;

export function Background(props: {
  children: React.ReactNode;
  background: "home" | "cards";
  style?: CSSProperties;
}) {
  const { translate } = useTranslate();
  return (
    <Container background={props.background} style={props.style}>
      {props.children}
      {props.background === "home" && (
        <Footer>
          <span>{translate("components.Background.credits")}</span>
        </Footer>
      )}
      <LangButton />
    </Container>
  );
}
